import React, { useState } from 'react'
import { View, Text, TouchableOpacity, Image, StyleSheet } from 'react-native'
import XIcon from 'xui/components/XIcon'
import XText from 'xui/components/XText'

type ImageGalleryWebProps = {
  items: string[]
  initialIndex?: number
  renderItem?: (item: string, index: number) => React.ReactNode
}

const ImageGalleryWeb: React.FC<ImageGalleryWebProps> = ({ items, initialIndex = 0, renderItem }) => {
  const safeIndex = (index: number) => {
    if (index < 0) return 0
    if (index >= items.length) return items.length - 1
    return index
  }

  const [currentIndex, setCurrentIndex] = useState(() => safeIndex(initialIndex))

  if (!items || items.length === 0) return null

  const goPrev = () => {
    if (items.length <= 1) return
    setCurrentIndex((prev) => (prev === 0 ? items.length - 1 : prev - 1))
  }

  const goNext = () => {
    if (items.length <= 1) return
    setCurrentIndex((prev) => (prev === items.length - 1 ? 0 : prev + 1))
  }

  const currentItem = items[safeIndex(currentIndex)]

  return (
    <View style={styles.container}>
      {items.length > 1 && (
        <TouchableOpacity onPress={goPrev} style={styles.navLeft}>
          {/* <Text style={styles.navText}>{'<'}</Text> */}
          <XIcon name='chevron-left' family='MaterialCommunityIcons' size='xl' style={styles.navText} />
        </TouchableOpacity>
      )}

      <View style={styles.imageWrapper}>
        {renderItem ? (
          renderItem(currentItem, currentIndex)
        ) : (
          <Image source={{ uri: currentItem }} style={styles.image} resizeMode='contain' />
        )}
        <XText variant='primary' fontSize='lg' bold style={styles.indexOverlay}>
          {Math.min(currentIndex + 1, items.length)}/{items.length}
        </XText>
      </View>

      {items.length > 1 && (
        <TouchableOpacity onPress={goNext} style={styles.navRight}>
          {/* <Text style={styles.navText}>{'>'}</Text> */}
          <XIcon name='chevron-right' family='MaterialCommunityIcons' size='xl' style={styles.navText} />
        </TouchableOpacity>
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    // flex: 1,
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    // position: 'relative',
  },
  imageWrapper: {
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'black', // optional สำหรับ contrast
    overflow: 'hidden',
  },
  image: {
    width: '100%',
    height: '95%',
    resizeMode: 'contain',
  },
  indexOverlay: {
    position: 'absolute',
    top: 10,
    right: 15,
    // color: 'white',
    backgroundColor: 'rgba(0,0,0,0.6)',
    paddingHorizontal: 8,
    paddingVertical: 2,
    borderRadius: 5,
    // fontSize: 14,
  },
  navLeft: {
    position: 'absolute',
    left: 10,
    top: '50%',
    transform: [{ translateY: -20 }],
    zIndex: 10,
  },
  navRight: {
    position: 'absolute',
    right: 10,
    top: '50%',
    transform: [{ translateY: -20 }],
    zIndex: 10,
  },
  navText: {
    fontSize: 32,
    // color: 'white',
    backgroundColor: 'rgba(0,0,0,0.5)',
    paddingHorizontal: 10,
    paddingVertical: 2,
    borderRadius: 5,
  },
})

export default ImageGalleryWeb
